import { filter, uniq } from 'lodash';
import urls from '../constants/urls';
import { removeFlash, addFlash } from './flashes';

import { paginationParams } from '../utils/pagination';
import { gatherErrors } from '../utils/errorHandling';
import {
  CHECKING_UNIQUENESS,
  CHECKING_UNIQUENESS_FAILED,
  UNIQUENESS,
} from './numbers';

export const EMAILS_LOAD_FAILED = 'emails/EMAILS_LOAD_FAILED';
export const EMAILS_LOAD_SUCCESS = 'emails/EMAILS_LOAD_SUCCESS';
export const LOADING_EMAILS = 'emails/LOADING_EMAILS';

export const CREATE_EMAIL_FAILED = 'emails/CREATE_EMAIL_FAILED';
export const CREATE_EMAIL_SUCCESS = 'emails/CREATE_EMAIL_SUCCESS';
export const CREATING_EMAIL = 'emails/CREATING_EMAIL';

export const DELETE_EMAIL_FAILED = 'email/DELETE_EMAIL_FAILED';
export const DELETE_EMAIL_SUCCESS = 'email/DELETE_EMAIL_SUCCESS';
export const DELETING_EMAIL = 'email/DELETING_EMAIL';

export const COPY_EMAIL_SUCCESS = 'email/COPY_EMAIL_SUCCESS';

const initialState = {
  emails: [],
  createErrors: {},

  failedCreating: false,
  failedDelete: false,
  failedLoading: false,

  hasLoaded: false,

  isCreating: false,
  isDeleting: false,
  isLoading: false,

  page: 1,
  pages: 1,
  total: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_EMAILS:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case EMAILS_LOAD_SUCCESS:
      return {
        ...state,
        emails: action.payload.data.data,
        ...paginationParams(
          action.payload.headers['link'],
          action.payload.headers['x-total']
        ),
        isLoading: false,
        failedLoading: false,
        hasLoaded: true,
      };

    case EMAILS_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };

    case CREATING_EMAIL:
      return {
        ...state,
        createErrors: {},
        isCreating: true,
        failedCreating: false,
      };

    case CREATE_EMAIL_SUCCESS:
      return {
        ...state,
        createErrors: {},
        isCreating: false,
      };

    case CREATE_EMAIL_FAILED:
      return {
        ...state,
        createErrors: gatherErrors(action.error, 'create_entry_failed'),
        isCreating: false,
        failedCreating: true,
      };

    case DELETING_EMAIL:
      return {
        ...state,
        failedDelete: false,
        isDeleting: true,
      };

    case DELETE_EMAIL_SUCCESS:
      const newEmails = uniq(
        filter(
          state.emails,
          email => email.id !== action.meta.previousAction.email.id
        )
      );

      return {
        ...state,
        emails: newEmails,
        isDeleting: false,
      };

    case DELETE_EMAIL_FAILED:
      return {
        ...state,
        failedDelete: true,
        isDeleting: false,
      };

    default:
      return state;
  }
};

export const createEmail = (hospitalId, params) => dispatch => {
  const emailParams = {
    title: params.title,
    value: params.value,
  };

  return dispatch({
    types: [CREATING_EMAIL, CREATE_EMAIL_SUCCESS, CREATE_EMAIL_FAILED],
    payload: {
      request: {
        method: 'post',
        url: urls.workspaces.emails.create(hospitalId),
        data: { email_address: emailParams },
      },
    },
  });
};

export const loadEmails = (hospital, page = 1, searchTerm) => dispatch => {
  return dispatch({
    types: [LOADING_EMAILS, EMAILS_LOAD_SUCCESS, EMAILS_LOAD_FAILED],
    payload: {
      request: {
        url: urls.workspaces.emails.index(hospital.id),
        params: { page, search_string: searchTerm },
      },
    },
  });
};

export const deleteEmail = (hospital, email) => dispatch => {
  return dispatch({
    types: [DELETING_EMAIL, DELETE_EMAIL_SUCCESS, DELETE_EMAIL_FAILED],
    payload: {
      request: {
        method: 'delete',
        url: urls.workspaces.emails.destroy(hospital.id, email),
      },
    },
    email,
  });
};

export const copyEmail = email => dispatch => {
  var textField = document.createElement('textarea');
  textField.innerText = email.value;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
  addFlash(COPY_EMAIL_SUCCESS)(dispatch);
  removeFlash('success', 'Email was copied successfully', dispatch);
};

export const checkUniqueness = (hospitalId, params) => dispatch => {
  const emailParams = {
    value: params.value,
    title: params.title,
  };

  return dispatch({
    types: [CHECKING_UNIQUENESS, UNIQUENESS, CHECKING_UNIQUENESS_FAILED],
    payload: {
      request: {
        method: 'get',
        url: urls.workspaces.emails.new(hospitalId),
        params: emailParams,
      },
    },
  });
};
